import React from 'react';
import { Tooltip } from 'src/client/components/ui/Tooltip';
import { ImageButton, NavbarIcon } from './styles';
import { NavLink } from 'react-router-dom';
import { faCog } from '@fortawesome/pro-light-svg-icons';
import { useSettingsNavigation } from './helpers/useSettingsNavigation';

export const SettingsButton = () => {
  const { handleSettingsClick } = useSettingsNavigation();

  return (
    <Tooltip value="Settings" placement="bottom">
      <ImageButton className="clickable">
        <NavLink to={{ pathname: '/settings', state: { canGoBack: true } }} onClick={handleSettingsClick}>
          <NavbarIcon icon={faCog} />
        </NavLink>
      </ImageButton>
    </Tooltip>
  );
};
